import React from "react";
import { Box, Button, TextField, styled } from "@mui/material";
import PropTypes from "prop-types";
import { FormattedMessage } from 'react-intl';

const Container = styled(Box)({});

const EditableText = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    border: 'transparent',
    borderBottom: '1px solid #787878',
    backgroundColor: 'transparent',
    outline: 'none',
    cursor: 'text',
    paddingBottom: '5px',
    fontSize: theme?.typography?.body2?.fontSize || '14px',
    '& fieldset': {
      border: 'none',
    },
    '&:hover fieldset': {
      border: 'none',
    },
    '&.Mui-focused fieldset': {
      border: 'none',
      borderBottom: '2px solid #1976d2',
    },
  },
  '& .MuiInputBase-input': {
    padding: '8px 0',
    fontSize: theme?.typography?.body2?.fontSize || '14px',
    '&::placeholder': {
      color: '#787878',
      opacity: 1,
    },
  },
}));

const ButtonContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  marginTop: '10px',
  gap: '10px',
});

const StyledButton = styled(Button)(({ rightButton, theme }) => ({
  minWidth: '100px',
  height: '36px',
  textTransform: 'none',
  fontWeight: 500,
  fontSize: '14px',
  borderRadius: '6px',
  transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
  '&:hover': {
    transform: 'translateY(-1px)',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
  },
}));

export const EditText = ({
  id,
  value,
  onTextChange,
  onCancel,
  onSave
}) => {

  const handleChange = (event) => {
    onTextChange(event.target.value);
  };

  return (
    <Container>
      <EditableText
        id={"edit_text_" + id}
        variant="standard"
        placeholder="Bearbeiten"
        value={value}
        onChange={handleChange}
        sx={{
          width: '100%',
          '& .MuiInput-underline:before': {
            borderBottom: '1px solid #787878',
          },
          '& .MuiInput-underline:after': {
            borderBottom: '2px solid #1976d2',
          },
          '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
            borderBottom: '1px solid #787878',
          },
        }}
      />
      <ButtonContainer>
        <StyledButton
          variant="outlined"
          onClick={onCancel}
        >
          <FormattedMessage id="general.abort" />
        </StyledButton>
        <StyledButton
          variant="contained"
          onClick={onSave}
        >
          <FormattedMessage id="general.edit" />
        </StyledButton>
      </ButtonContainer>
    </Container>
  );
};

EditText.defaultProps = {};

EditText.propTypes = {
  id: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onTextChange: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired
};
